import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles, colourStyles2} from '../../styles/styles'
import CreatableSelect from 'react-select/creatable'
import makeAnimated from 'react-select/animated'
import {ErrorMessage, Field, useField} from 'formik'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import Select from 'react-select'
const API_URL = process.env.REACT_APP_API_URL || 'api'

interface UseOption {
  readonly value: number
  readonly label: string
}

const Step1: FC = () => {
  const animatedComponents = makeAnimated()
  const intl = useIntl()
  const [fieldResponsibleID, metaResponsibleID, helperResponsibleID] = useField('responsible_id')
  const [fieldEmail, , helperEmail] = useField('external_email')
  const [fieldProjectID, ,] = useField('project_id')
  const [fieldDescription, metaDescription] = useField('description')
  const [fieldProvidenceNumber, metaProvidenceNumber] = useField('providence_number')

  const [selectedResponsibleID, setSelectedResponsibleID] = useState([])
  const [selectedEmail, setSelectedEmail] = useState([])
  const [disableUsers, setDisableUsers] = useState(false)

  //função de load do select2 de usuarios responsaveis -- responsible_id
  const loadOptionsResponsibleID = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      var options: any[] = []

      let responsibleIdinit = fieldResponsibleID.value

      async function getUser() {
        let project_id = parseInt(fieldProjectID.value)
        const {data} = await axios.get(`${API_URL}/v1/users/select2?sga_project_id=${project_id}`)
        let Response = data.results
        console.log('Response', Response)

        setDisableUsers(false)
        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const unit: any = {
              value: Response[i].id,
              label: Response[i].username,
            }
            units.push(unit)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (responsibleIdinit) {
              for (var j = 0; j < responsibleIdinit.length; j++) {
                if (parseInt(responsibleIdinit[j]) === Response[i].id) {
                  options.push(unit)
                }
              }
            }
          }
        } else {
          setDisableUsers(true)
        }
        setSelectedResponsibleID(options as any)
      }
      callback(units)
    }, 1000)
  }

  //função onchange do select2 de usuarios responsaveis -- responsible_id
  const handleInputChangeResponsibleIDs = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(event[i].value)
      }
    }
    setSelectedResponsibleID(event)
    helperResponsibleID.setValue(inputValue)
    return {inputValue}
  }

  const handleInputChangeEmails = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(event[i].value)
      }
    }
    setSelectedEmail(event)
    helperEmail.setValue(inputValue)
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>{intl.formatMessage({id: 'PROVIDENCE.STEP1'})}</h2>

          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'PROVIDENCE.STEP1SUB'})}
          </div>
        </div>

        <div className='card-body p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.NUMBER'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'COMMON.NUMBER'})}
                  {...fieldProvidenceNumber}
                />
                {metaProvidenceNumber.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaProvidenceNumber.error}
                  </div>
                ) : null}
              </div>
            </div>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>Código do Comunicado</label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  name='code'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Código do Comunicado'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='code' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da primeira linha */}

          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'USERS_RESPONSIBLE.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {disableUsers ? (
                  <Select
                    className='form-control form-control-lg form-control-transparent p-1 pl-1 ps-6 border border-1 border-gray-400'
                    styles={colourStyles2}
                    isDisabled={true}
                    placeholder='não há usuários disponíveis'
                  />
                ) : (
                  <AsyncSelect
                    className='form-control form-control-lg form-control-solid p-1 pl-1'
                    styles={colourStyles}
                    isMulti
                    components={animatedComponents}
                    cacheOptions
                    {...fieldResponsibleID}
                    loadOptions={loadOptionsResponsibleID}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    placeholder={intl.formatMessage({id: 'USERS.TITLE'})}
                    value={selectedResponsibleID}
                    onChange={handleInputChangeResponsibleIDs}
                  />
                )}
                {metaResponsibleID.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaResponsibleID.error}
                  </div>
                ) : null}
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'ENTERPRISES.INPUT_RESPONSIBLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  name='responsible'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'ENTERPRISES.INPUT_RESPONSIBLE'})}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='responsible' />
                </div>
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da quinta linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'USERS.INPUT_EMAIL'})}
              </label>
              <div className='d-flex position-relative my-1'>
                <CreatableSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1'
                  styles={colourStyles}
                  isMulti
                  placeholder={intl.formatMessage({id: 'USERS.INPUT_EMAIL'})}
                  isSearchable
                  components={animatedComponents}
                  {...fieldEmail}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  value={selectedEmail}
                  onChange={handleInputChangeEmails}
                />
              </div>
            </div>
          </div>
          {/* fim da quinta linha */}
          {/* inicio da sexta linha */}
          <div className='row mt-3'>
            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  as='textarea'
                  rows={5}
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  {...fieldDescription}
                />
                {metaDescription.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaDescription.error}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* fim da sexta linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step1}
